/**
 * Assembles header, body, and footer into a unified document structure
 * This does NOT render tokens - it only combines the structure
 * 
 * @param {Object} sections - Object with header, body, footer properties
 * @returns {string} - Combined HTML structure ready for rendering
 */
export function assembleDocument({ header, body, footer }) {
  // Combine sections with proper spacing
  // This preserves the structure while allowing renderTemplate to process all tokens
  let combined = '';
  
  if (header) {
    combined += header;
  }
  
  if (body) {
    // Add spacing between header and body if header exists
    if (header) {
      combined += '<p><br></p>';
    }
    combined += body;
  }
  
  if (footer) {
    // Add spacing between body and footer if body exists
    if (body || header) {
      combined += '<p><br></p><p><br></p>';
    }
    combined += footer;
  }
  
  return combined || '';
}
